import React from 'react';

import { styled } from 'styled-components';
import Image from 'next/image';
import { ButtonPrimary } from '../../../../../ui/atoms/Button';
import { H8Styles, H5Styles } from '../../../../Typography';
import config from '../../../../../../config.json';

const { routes } = config;

const MastheadWrapper = styled.div`
  height: 650px;
  background: linear-gradient(180deg, #b472fb 0%, #7357f2 100%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}px) {
    height: 285px;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 268px;
  height: 37px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}px) {
    width: 388px;
    height: 53px;
  }
`;

const SubHeading = styled.div`
  ${H8Styles}
  color: ${({ theme }) => theme.colors.neutral1};
  margin: 18px 0 28px 0;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}px) {
    ${H5Styles}
    color: ${({ theme }) => theme.colors.neutral1};
  }
`;

const DefaultMasthead: React.FC = () => (
  <MastheadWrapper>
    <ImageWrapper>
      <Image src="/assets/makeship-logo-white.png" alt="Makeship Logo" fill style={{ objectFit: 'contain' }} />
    </ImageWrapper>
    <SubHeading>Designed by Creators. Fueled by Fans.</SubHeading>
    <ButtonPrimary href={routes.shopLive}>Explore Campaigns</ButtonPrimary>
  </MastheadWrapper>
);

export default DefaultMasthead;
